export default __webpack_public_path__ + "media/images/fleche2-bb07f07dc00376092f331ae49756c062.png";